// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-auth{display:flex;max-width:37rem;flex-direction:column;margin-left:auto;margin-right:auto}.ac-auth--register{max-width:55rem}.ac-auth__title,.ac-auth__descr{text-align:center;color:#fff}.ac-auth__title{margin-top:55px;font-size:2.2rem;font-family:\"Montserrat\";text-transform:uppercase}.ac-auth__descr{background:#24768E;line-height:20px;margin-top:20px;padding:20px;width:100%}.ac-auth__form{margin-top:30px}\n", ""]);
// Exports
module.exports = exports;
